import React, { Component } from 'react';
import {
  Divider,
  Switch,
  Button,
  Slider,
  FormGroup,
  MenuItem,
} from '@blueprintjs/core';
import { Cell, Column, Table, RenderMode } from '@blueprintjs/table';
import { MultiSelect } from '@blueprintjs/select';
import {
  arrayContainsFilm,
  maybeAddCreatedFilmToArrays,
  maybeDeleteCreatedFilmFromArrays,
  TOP_100_FILMS,
} from './films';

import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Features extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      PartyMob: true,
      MinPlayerForPartyMob: 2,
      AvatarMagicOptExploitFix: true,
      CastBreakFix: true,
      ExchangeStallSpamFix: true,
      FellowPetFixes: true,
      HideGoldPriceError: true,
      HideQuestRaiseError: true,
      AttendanceCheckEvent: true,
      ColouredGlobals: true,
      DPSMeterWindow: true,
      DynamicRanking: true,
      HWANColor: true,
      OnlyChinaCreate: true,
      PartyMobConfig: true,
      PlayerNameColor: true,
      RankWindow: true,
      SimpleGlobalScoreBoard: true,
      TitleWindow: true,
      UniqueKillNoticeForGM: true,
      UniqueTarget: true,
      WrongPasswordFix: true,
      OldChat: true,
      OldGuild: true,
      OldItemMall: true,
      OldLogin: true,
      OldOptionWindow: true,
      OldPvpCape: true,
      OldTargetWindow: true,
      OldTooltip: true,
      OldUnderbar: true,
      OldQuestWindow: true,
      OldWorldMap: true,
      OldWindowSidebar: true,
      PtMobDisabledRegions: ['Jangan', 'Hotan'],
      PtMobDisabledGameWorlds: [
        { ID: 1, Name: 'Jangan' },
        { ID: 2, Name: 'Dowhang' },
        { ID: 3, Name: 'Hotan' },
        { ID: 4, Name: 'Samarkand' },
        { ID: 5, Name: 'Constantine' },
        { ID: 6, Name: 'Alexander' },
        { ID: 7, Name: 'Jangan Cave' },
        { ID: 8, Name: 'Dowhang Cave' },
        { ID: 9, Name: 'Karakoram' },
        { ID: 10, Name: 'Taklamakan' },
        { ID: 11, Name: 'Oasis' },
        { ID: 12, Name: 'Anatolia' },
      ],
      PtMobDisabledGameWorldsFiltered: [],
      PtMobDisabledGameWorldsFilter: '',
      items: TOP_100_FILMS,
      films: [],
      createdItems: [],
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };

    this.filterTable = (Table) => (Callback) => {
      if (!Callback) Callback = (x) => x;

      let FilterString = (Callback.target && Callback.target.value) || Callback;

      if (typeof Callback !== 'function') {
        FilterString = typeof FilterString === 'string' ? FilterString : '';

        this.setState({
          [`${Table}Filter`]: FilterString,
        });

        Callback = ((y) => (x) => x.Name.toLowerCase().indexOf(y) !== -1)(
          FilterString.toLowerCase()
        );
      }

      this.setState({
        [`${Table}Filtered`]: this.state[Table].filter(Callback).slice(0, 5),
      });
    };

    this.getSelectedFilmIndex = (film) => {
      return this.state.films.indexOf(film);
    };

    this.isFilmSelected = (film) => {
      return this.getSelectedFilmIndex(film) !== -1;
    };

    this.renderFilm = (film, { modifiers, handleClick }) => {
      if (!modifiers.matchesPredicate) return null;

      return (
        <MenuItem
          active={modifiers.active}
          icon={this.isFilmSelected(film) ? 'tick' : 'blank'}
          key={film.rank}
          label={film.year.toString()}
          onClick={handleClick}
          text={`${film.rank}. ${film.title}`}
          shouldDismissPopover={false}
        />
      );
    };

    this.handleFilmSelect = (film) => {
      if (!this.isFilmSelected(film)) this.selectFilm(film);
      else this.deselectFilm(this.getSelectedFilmIndex(film));
    };

    this.selectFilm = (film) => {
      this.selectFilms([film]);
    };

    this.selectFilms = (filmsToSelect) => {
      const { createdItems, films, items } = this.state;

      let nextCreatedItems = createdItems.slice();
      let nextFilms = films.slice();
      let nextItems = items.slice();

      filmsToSelect.forEach((film) => {
        const results = maybeAddCreatedFilmToArrays(
          nextItems,
          nextCreatedItems,
          film
        );
        nextItems = results.items;
        nextCreatedItems = results.createdItems;
        // Avoid re-creating an item that is already selected (the "Create
        // Item" option will be shown even if it matches an already selected
        // item).
        nextFilms = !arrayContainsFilm(nextFilms, film)
          ? [...nextFilms, film]
          : nextFilms;
      });

      this.setState({
        createdItems: nextCreatedItems,
        films: nextFilms,
        items: nextItems,
      });
    };

    this.deselectFilm = (index) => {
      const { films } = this.state;

      const film = films[index];

      const {
        createdItems: nextCreatedItems,
        items: nextItems,
      } = maybeDeleteCreatedFilmFromArrays(
        this.state.items,
        this.state.createdItems,
        film
      );

      // Delete the item if the user manually created it.
      this.setState({
        createdItems: nextCreatedItems,
        films: films.filter((_film, i) => i !== index),
        items: nextItems,
      });
    };
  }

  componentDidMount() {
    this.filterTable('PtMobDisabledGameWorlds')();
  }

  render() {
    const SwitchOnOff = {
      innerLabelChecked: 'on',
      innerLabel: 'off',
    };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Extended Filter Features
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border mb-4">
          <tbody>
            <tr>
              <td>Spawn Party Mobs</td>
              <td>
                <Switch
                  checked={this.state.PartyMob}
                  {...SwitchOnOff}
                  onChange={this.handleChange('PartyMob')}
                />
              </td>
            </tr>

            <tr>
              <td>Party Mobs Disabled on</td>
              <td>
                {this.state.PartyMob ? (
                  <Table numRows={this.state.PtMobDisabledRegions.length}>
                    <Column
                      name="Region CodeName"
                      cellRenderer={(x) => (
                        <Cell>{this.state.PtMobDisabledRegions[x]}</Cell>
                      )}
                    />
                  </Table>
                ) : (
                  ''
                )}
                <Button
                  disabled={!this.state.PartyMob}
                  className="mt-2"
                  icon="add"
                  text="Add"
                />
              </td>
            </tr>

            <tr>
              <td>Party Mobs Disabled on</td>
              <td>
                <MultiSelect
                  itemRenderer={this.renderFilm}
                  tagRenderer={(film) => film.title}
                  items={this.state.items}
                  onItemSelect={this.handleFilmSelect}
                />

                <hr />

                {this.state.PartyMob ? (
                  <div>
                    <input
                      type="text"
                      className="bp3-input d-block w-75 mb-2"
                      placeholder="Search in GameWorlds..."
                      value={this.state.PtMobDisabledGameWorldsFilter}
                      onChange={this.filterTable('PtMobDisabledGameWorlds')}
                    />

                    <Table
                      renderMode={RenderMode.NONE}
                      numRows={
                        this.state.PtMobDisabledGameWorldsFiltered.length
                      }
                    >
                      {Object.keys(this.state.PtMobDisabledGameWorlds[0]).map(
                        (Col) => {
                          return (
                            <Column
                              name={Col}
                              key={Col}
                              cellRenderer={(RowIndex) => (
                                <Cell key={RowIndex}>
                                  {
                                    this.state.PtMobDisabledGameWorldsFiltered[
                                      RowIndex
                                    ][Col]
                                  }
                                </Cell>
                              )}
                            />
                          );
                        }
                      )}
                    </Table>
                  </div>
                ) : (
                  ''
                )}
                <Button
                  disabled={!this.state.PartyMob}
                  className="mt-2"
                  icon="add"
                  text="Add"
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="for Spawn Party Mobs" className="mb-0">
                  Minimum Players in Party
                </FormGroup>
              </td>
              <td style={{ width: '360px' }}>
                <Slider
                  disabled={!this.state.PartyMob}
                  min={1}
                  max={8}
                  onChange={this.handleChange('MinPlayerForPartyMob')}
                  value={this.state.MinPlayerForPartyMob}
                  className="mb-4"
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td className="mb-4"></td>
            </tr>
          </tbody>
        </table>

        <div className="row">
          <div className="col">
            <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border d-block w-100">
              <tbody>
                <tr>
                  <td style={{ minWidth: '240px' }}>
                    Avatar Magic Opt. Exploit Fix
                  </td>
                  <td>
                    <Switch
                      checked={this.state.AvatarMagicOptExploitFix}
                      {...SwitchOnOff}
                      onChange={this.handleChange('AvatarMagicOptExploitFix')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Cast Break Fix</td>
                  <td>
                    <Switch
                      checked={this.state.CastBreakFix}
                      {...SwitchOnOff}
                      onChange={this.handleChange('CastBreakFix')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Exchange & Stall Spam Fix</td>
                  <td>
                    <Switch
                      checked={this.state.ExchangeStallSpamFix}
                      {...SwitchOnOff}
                      onChange={this.handleChange('ExchangeStallSpamFix')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Coloured Globals</td>
                  <td>
                    <Switch
                      checked={this.state.ColouredGlobals}
                      {...SwitchOnOff}
                      onChange={this.handleChange('ColouredGlobals')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>DPS Meter Window</td>
                  <td>
                    <Switch
                      checked={this.state.DPSMeterWindow}
                      {...SwitchOnOff}
                      onChange={this.handleChange('DPSMeterWindow')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Dynamic Ranking</td>
                  <td>
                    <Switch
                      checked={this.state.DynamicRanking}
                      {...SwitchOnOff}
                      onChange={this.handleChange('DynamicRanking')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Hwan(Zerk) Color</td>
                  <td>
                    <Switch
                      checked={this.state.HWANColor}
                      {...SwitchOnOff}
                      onChange={this.handleChange('HWANColor')}
                      className="mb-0"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="col">
            <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border d-block w-100">
              <tbody>
                <tr>
                  <td style={{ minWidth: '240px' }}>Player Name Color</td>
                  <td>
                    <Switch
                      checked={this.state.PlayerNameColor}
                      {...SwitchOnOff}
                      onChange={this.handleChange('PlayerNameColor')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Rank Window</td>
                  <td>
                    <Switch
                      checked={this.state.RankWindow}
                      {...SwitchOnOff}
                      onChange={this.handleChange('RankWindow')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Simple Global Score Board</td>
                  <td>
                    <Switch
                      checked={this.state.SimpleGlobalScoreBoard}
                      {...SwitchOnOff}
                      onChange={this.handleChange('SimpleGlobalScoreBoard')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Title Window</td>
                  <td>
                    <Switch
                      checked={this.state.TitleWindow}
                      {...SwitchOnOff}
                      onChange={this.handleChange('TitleWindow')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Unique Kill Notice for GM</td>
                  <td>
                    <Switch
                      checked={this.state.UniqueKillNoticeForGM}
                      {...SwitchOnOff}
                      onChange={this.handleChange('UniqueKillNoticeForGM')}
                      className="mb-0"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Unique Target</td>
                  <td>
                    <Switch
                      checked={this.state.UniqueTarget}
                      {...SwitchOnOff}
                      onChange={this.handleChange('UniqueTarget')}
                      className="mb-0"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <hr />

        <div className="d-block text-center">
          <Button className="mt-2" icon="floppy-disk" text="Save" />
        </div>
      </SideMenuWrapper>
    );
  }
}
